import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { rootRoute } from "../__root";

export const usersSignInRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/users/sign_in",
  component: lazyRouteComponent(
    () =>
      import(
        /* webpackChunkName: "OnboardingSignInPage" */ "@circle-react/components/OnboardingPage/SignInPage"
      ),
    "SignInPage",
  ),
});
